'use client';
import { useContext, useEffect, useState } from 'react';
import { LineItem } from 'shared/types/cart';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { TealiumUTag } from 'shared/types/tealium/TealiumUTag';
import Notification from '@/components/customercenter-ui/components/notification';
import { Button } from '@/components/customercenter-ui/components/ui/button';
import ErrorIcon from '@/components/customercenter-ui/svgs/notifications/error';
import { triggerTealiumEvent, getPageUtagData } from '@/components/customercenter-ui/utils/tealiumUtils';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { routerUrl } from '@/helpers/utils/routerUrl';
import PdpAccordianDetail from './PdpAccordianDetail';
import PdpCarouselImages from './PdpCarouselImages';
import PdpColorFilter from './pdpColorFilter';
import ProductNameSection from './productNameSection';
import { ProductContext } from '../../contexts';
import { getFilteredAttribute } from '../../helpers/utils/productDataUtils';
interface ProductDetailsDesktopProps {
  setNotificationMessage: (message: string) => void;
  setIsError: (isError: boolean) => void;
  setSeeSimilarItems: (isSimilar: boolean) => any;
}

const ProductDetailsDesktop: React.FC<ProductDetailsDesktopProps> = ({
  setNotificationMessage,
  setIsError,
  setSeeSimilarItems,
}) => {
  const { productData, product, initialColor, initialSize } = useContext(ProductContext);
  const projectSettings: ProjectSettings = useProjSettings();
  const [isEditCart, setIsEditCart] = useState<boolean>(false);
  const [lineItem, setLineItem] = useState<LineItem>();
  const [selectedWarranty, setSelectedWarranty] = useState<LineItem>();

  useEffect(() => {
    try {
      const editPersonalizationData = sessionStorage.getItem('editPersonalizationData');
      if (editPersonalizationData) {
        const epData = JSON.parse(editPersonalizationData);
        if (epData) {
          const lineItem = epData?.lineItem;
          const selectedWarranty = epData?.selectedWarranty;
          const personalizeProductId = lineItem?.personalizeProductId;
          if (personalizeProductId) {
            if (selectedWarranty?.variant?.sku) {
              setSelectedWarranty(selectedWarranty);
            }
            setLineItem(lineItem);
            setIsEditCart(true);
          }
        }
      }
      sessionStorage.removeItem('editPersonalizationData');
    } catch (error) {
      console.error('Error while parsing json');
    }
  }, []);

  const closeArtifiError = () => {
    if (isEditCart) {
      window.location.href = routerUrl.cart;
    } else {
      const personalizeDivError = document.getElementById('artifiPersonalizationError');
      if (personalizeDivError) {
        personalizeDivError.style.left = '';
        personalizeDivError.classList.remove('na');
      }
    }
  };

  useEffect(() => {
    if (productData && product) {
      const pageUtagData: TealiumUTag = getPageUtagData(
        'PDP',
        undefined,
        undefined,
        {
          productData,
          product,
          initialColor,
          initialSize,
        },
        undefined,
        undefined,
        undefined,
        projectSettings,
      );
      triggerTealiumEvent(pageUtagData);
    }
  }, [productData, product]);

  return (
    <>
      <section className="relative w-full">
        {getFilteredAttribute('personalizeOption', initialColor?.masterVariant) === true && (
          <>
            <style>
              {`
              #artifiPersonalization.in + #artifiPersonalizationError + section > section:first-child > section, #artifiPersonalization.in + #artifiPersonalizationError + section > section:first-child + section > section:not(:last-child), #artifiPersonalization.in + #artifiPersonalizationError + section > section:first-child + section > section:last-child > section > section:not(:last-child){display: none;}          
              #artifiPersonalization.in{position: relative !important;}
              #artifiPersonalizationError.na + section > section:first-child > section, #artifiPersonalizationError.na + section > section:first-child + section > section:not(:last-child), #artifiPersonalizationError.na + section > section:first-child + section > section:last-child > section > section:not(:last-child){display: none;}          
              #artifiPersonalizationError.na{position: relative !important;}
            `}
            </style>
            <div
              id="artifiPersonalization"
              className="transition-left absolute -left-[9999px] top-0 z-[1] h-full w-full bg-white duration-500"
            ></div>
            <div
              id="artifiPersonalizationError"
              className="transition-left absolute -left-[9999px] top-0 z-[1] flex h-full w-full flex-col items-center justify-center bg-white duration-500"
            >
              <Notification
                message={mapLocaleToMeaningfulFormat().personalizeError}
                isError={true}
                color={'bg-[#FFEBEB]'}
                textColor={'text-black font-medium'}
                icon={<ErrorIcon className="h-5 w-5" />}
                closeFlag={false}
              />
              <div>
                <Button className="mt-5" onClick={closeArtifiError}>
                  {mapLocaleToMeaningfulFormat().cancel}
                </Button>
              </div>
            </div>
          </>
        )}

        <section className="relative flex gap-10">
          <section className="sticky top-0 h-full w-[505px]">
            <PdpCarouselImages />
          </section>
          <section className="w-[505px]">
            <ProductNameSection />
            <PdpColorFilter
              isEditCart={isEditCart}
              lineItem={lineItem}
              selectedWarranty={selectedWarranty}
              setNotificationMessage={setNotificationMessage}
              setIsError={setIsError}
              setSeeSimilarItems={setSeeSimilarItems}
            />
            <PdpAccordianDetail />
          </section>
        </section>
      </section>
    </>
  );
};
export default ProductDetailsDesktop;
